import {
    GET_KATEGORI_ASN,
    GET_DETAIL_KATEGORI_ASN,
    GET_STATUS_PEGAWAI,
    GET_DETAIL_STATUS_PEGAWAI,
    GET_PENGHARGAAN_SLKS,
    GET_DETAIL_PENGHARGAAN_SLKS,
    GET_GENDER,
    GET_DETAIL_GENDER,
    GET_PERKAWINAN,
    GET_DETAIL_PERKAWINAN,
    GET_AGAMA,
    GET_DETAIL_AGAMA,
    GET_GOLDAR,
    GET_DETAIL_GOLDAR,
    GET_UNKER,
    GET_TIM_KERJA,
    GET_FORMASI_CPNS,
    GET_STATUS_FORMASI_CPNS,
    GET_CPNS_FUNGSIONAL_TIPE,
    GET_CPNS_FUNGSIONAL_KODE,
    GET_LIST_PENDIDIKAN,
    GET_LIST_PRODI,
    GET_SEARCH_PEGAWAI,
    RESET_SEARCH_PEGAWAI,
    GET_LOKASI,
    GET_KOTA_BY_PROVINSI,
    GET_PROVINSI_BY_NEGARA,
    GET_KECAMATAN_BY_KOTA,
    GET_KELURAHAN_BY_KECAMATAN,
    GET_LIST_ESELON,
    GET_UNKER_GENERAL,
    GET_LIST_PENDIDIKAN_ID,
    GET_LIST_PRODI_BY_PENDIDIKAN,
    GET_LIST_GOLONGAN,
    GET_LIST_TIPE_JABATAN,
    GET_LIST_JABFUNG,
    GET_LIST_JABFUNG_GENERAL,
    GET_LIST_CLUSTER,
    GET_LIST_SUBCLUSTER,
    GET_UNKER_CHOICE,
    GET_JABATAN_BY_UNKER,
    GET_PELANGGARAN_PP,
    GET_KODE_HUKUMAN,
    GET_KODE_PEJABAT_BERWENANG,
    GET_PENYAMPAIAN_KEPUTUSAN_HUKUMAN,
    GET_UPAYA_ADMINISTRATIF,
    GET_STATUS_HUKDIS,
    GET_LIST_GAJI,
    GET_LIST_GOLONGAN_CHOICE,
    GET_ALL_UNKER,
    GET_LIST_NEGARA,
    GET_KATEGORI_PP_PELANGGARAN,
    GET_LIST_TINGKAT_PENDIDIKAN,
    GET_OPTION_SHIFT,
    RESET_LIST_JABFUNG,
    GET_OPTION_JURUSAN,
    GET_OPTION_SEKOLAH,
    RESET_OPTION_JURUSAN,
    GET_OPTION_JENIS_DIKLAT,
    GET_OPTION_KATEGORI_DIKLAT,
    GET_ESELON_OPTION,
    RESET_UNKER_LEVEL_CHOICE,
    GET_PEGAWAI_PENSIUN_OPTION,
    GET_LIST_MENUS,
    GET_OPTION_BIDANG_KEAHLIAN,
    GET_KATEGORI_ASN_V2,
    GET_KATEGORI_ASN_TIPE_V2,
    RESET_KATEGORI_ASN_TIPE_V2,
    GET_OPTION_PROGRAM_KERJA,
    GET_OPTION_STATUS_PROGRAM_KERJA,
    GET_OPTION_INTERVENSI_PROGRAM_KERJA,
    GET_JABATAN,
    RESET_JABATAN_OPTION,
    GET_OPTION_INDIKATOR_ASSESSMENT,
    GET_OPTION_PENGHARGAAN_ASN,
} from 'shared/constants/ActionTypes';

const negaraChoices = [
    { id: "AFGHANISTAN", label: "AFGHANISTAN" },
    { id: "ALAND ISLANDS", label: "ALAND ISLANDS" },
    { id: "ALBANIA", label: "ALBANIA" },
    { id: "ALGERIA", label: "ALGERIA" },
    { id: "AMERICAN SAMOA", label: "AMERICAN SAMOA" },
    { id: "ANDORRA", label: "ANDORRA" },
    { id: "ANGOLA", label: "ANGOLA" },
    { id: "ANGUILLA", label: "ANGUILLA" },
    { id: "ANTARCTICA", label: "ANTARCTICA" },
    { id: "ANTIGUA AND BARBUDA", label: "ANTIGUA AND BARBUDA" },
    { id: "ARGENTINA", label: "ARGENTINA" },
    { id: "ARMENIA", label: "ARMENIA" },
    { id: "ARUBA", label: "ARUBA" },
    { id: "AUSTRALIA", label: "AUSTRALIA" },
    { id: "AUSTRIA", label: "AUSTRIA" },
    { id: "AZERBAIJAN", label: "AZERBAIJAN" },
    { id: "BAHAMAS", label: "BAHAMAS" },
    { id: "BAHRAIN", label: "BAHRAIN" },
    { id: "BANGLADESH", label: "BANGLADESH" },
    { id: "BARBADOS", label: "BARBADOS" },
    { id: "BELARUS", label: "BELARUS" },
    { id: "BELGIUM", label: "BELGIUM" },
    { id: "BELIZE", label: "BELIZE" },
    { id: "BENIN", label: "BENIN" },
    { id: "BERMUDA", label: "BERMUDA" },
    { id: "BHUTAN", label: "BHUTAN" },
    { id: "BOLIVIA", label: "BOLIVIA" },
    { id: "BOSNIA AND HERZEGOVINA", label: "BOSNIA AND HERZEGOVINA" },
    { id: "BOTSWANA", label: "BOTSWANA" },
    { id: "BOUVET ISLAND", label: "BOUVET ISLAND" },
    { id: "BRAZIL", label: "BRAZIL" },
    { id: "BRITISH INDIAN OCEAN TERRITORY", label: "BRITISH INDIAN OCEAN TERRITORY" },
    { id: "BRUNEI DARUSSALAM", label: "BRUNEI DARUSSALAM" },
    { id: "BULGARIA", label: "BULGARIA" },
    { id: "BURKINA FASO", label: "BURKINA FASO" },
    { id: "BURUNDI", label: "BURUNDI" },
    { id: "CAMBODIA", label: "CAMBODIA" },
    { id: "CAMEROON", label: "CAMEROON" },
    { id: "CANADA", label: "CANADA" },
    { id: "CAPE VERDE", label: "CAPE VERDE" },
    { id: "CAYMAN ISLANDS", label: "CAYMAN ISLANDS" },
    { id: "CENTRAL AFRICAN REPUBLIC", label: "CENTRAL AFRICAN REPUBLIC" },
    { id: "CHAD", label: "CHAD" },
    { id: "CHILE", label: "CHILE" },
    { id: "CHINA", label: "CHINA" },
    { id: "CHRISTMAS ISLAND", label: "CHRISTMAS ISLAND" },
    { id: "COCOS (KEELING) ISLANDS", label: "COCOS (KEELING) ISLANDS" },
    { id: "COLOMBIA", label: "COLOMBIA" },
    { id: "COMOROS", label: "COMOROS" },
    { id: "CONGO", label: "CONGO" },
    { id: "CONGO, THE DEMOCRATIC REPUBLIC OF THE", label: "CONGO, THE DEMOCRATIC REPUBLIC OF THE" },
    { id: "COOK ISLANDS", label: "COOK ISLANDS" },
    { id: "COSTA RICA", label: "COSTA RICA" },
    { id: "INDONESIA", label: "INDONESIA" },
    { id: "Jepang", label: "Jepang" }
]

const INIT_STATE = {
    kategoriAsn: {
        list: null,
        detail: null,
        kategoriAsnChoice: [] //kategoriAsnChoice untuk list dropdown
    },
    kategoriAsnV2: {
        list: null,
        kategoriAsnV2Choice: [] //kategoriAsnChoice untuk list dropdown
    },
    tipeKategoriASNV2: {
        list: null,
        tipeKategoriASNV2Choice: [],
    },
    statusPegawai: {
        list: null,
        detail: null,
        statusPegawaiChoice: [],
    },
    penghargaanSlks: {
        list: null,
        detail: null
    },
    gender: {
        list: null,
        detail: null,
        genderChoice: [] //genderChoice untuk list dropdown
    },
    perkawinan: {
        list: null,
        detail: null
    },
    agama: {
        list: null,
        agamaChoice: [],
        detail: null,
    },
    golDar: {
        list: null,
        goldarChoice: [],
        detail: null,
    },
    unker: {
        list: null,
        unkerLevel: {
            level: '',
            choice: []
        },
        unkerChoice: [],   // unkerChoice untuk list dropdown autocomplete
        unkerGeneralChoice: [],
        unkerAllChoice: []
    },
    jabatan: {
        list: null,
        choice: [],
        byUnker: {
            list: null,
            choice: []
        }
    },
    timKerja: {
        list: null
    },
    formasiCPNS: {
        list: null
    },
    statusFormasiCPNS: {
        list: null
    },
    tipeCPNSFungsional: {
        list: null
    },
    kodeCPNSFungsional: {
        list: null
    },
    listPendidikan: {
        list: null
    },
    listProdi: {
        list: null
    },
    listTingkatPendidikan: {
        list: null,
        option: []
    },
    pegawai: {
        list: null,
        option: []
    },
    lokasi: {
        list: null,
        lokasiChoice: [] //lokasiChoice untuk list dropdown
    },
    negara: {
        option: negaraChoices
    },
    provinsi: {
        list: null,
        option: []
    },
    kota: {
        list: null,
        option: [],
    },
    kecamatan: {
        list: null,
        option: []
    },
    kelurahan: {
        list: null,
        option: []
    },
    eselon: {
        list: null,
        eselonChoice: [],
        eselonPNSOption: []
    },
    pendidikanId: {
        list: null,
        option: []
    },
    prodiByPendidikan: {
        list: null,
        option: []
    },
    listCluster: {
        list: null,
        option: [],
    },
    listSubcluster: {
        list: null,
        option: []
    },
    listGolongan: {
        list: null,
        option: []
    },
    tipeJabatan: {
        list: null,
        tipeJabatanChoice: []
    },
    listJabfung: {
        list: null,
        option: [],
        jabfungGeneralChoice: []
    },
    pelanggaranPPOption: {
        list: null,
        choice: []
    },
    kodeHukumanOption: {
        list: null,
        choice: []
    },
    kodePejabatBerwenangOption: {
        list: null,
        choice: []
    },
    pkhOption: {
        list: null,
        choice: []
    },
    upayaAdministratifOption: {
        list: null,
        choice: []
    },
    statusHukdisOption: {
        list: null,
        choice: []
    },
    gaji: {
        list: null,
        choice: []
    },
    golonganChoice: {
        choice: [],
    },
    kategoriPPPelanggaran: {
        list: null,
        choice: [],
    },
    shiftJadwalKerja: {
        choice: [],
    },
    listJurusan: {
        list: null,
        choice: [],
    },
    listSekolah: {
        list: null,
        choice: []
    },
    jenisDiklatOption: {
        choice: []
    },
    kategoriDiklatOption: {
        choice: []
    },
    pegawaiPensiunOption: {
        choice: []
    },
    menu: {
        choice: []
    },
    bidangKeahlian: {
        choice: []
    },
    programKerja: {
        tipe: [],
        status: [],
        intervensi: []
    },
    indikatorAssessment: {
        list: {
            results: []
        },
        choice: [],
    },
    penghargaanAsn: {
        list: {
            result: [],
        },
        choice: [],
    }
};

const filterReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_KATEGORI_ASN: {
            const kategoriAsnResults = action?.payload?.results || action.payload?.result
            const listKategoriAsn = kategoriAsnResults.filter((item) => item.nama !== null)
            const tmpChoice = listKategoriAsn.map((item) => ({ id: item.id, label: item.nama }))

            return {
                ...state,
                kategoriAsn: {
                    ...state.kategoriAsn,
                    list: kategoriAsnResults,
                    kategoriAsnChoice: tmpChoice
                }
            }
        }
        case GET_DETAIL_KATEGORI_ASN: {
            return {
                ...state,
                kategoriAsn: {
                    ...state.kategoriAsn,
                    detail: action.payload
                }
            }
        }
        case GET_STATUS_PEGAWAI: {
            const statusPegawaiResults = action?.payload?.results || action.payload?.result
            const listStatPegawai = []
            statusPegawaiResults.map((item) => {
                if (item.nama !== null) listStatPegawai.push({ id: item.id, label: item.nama })
            })

            return {
                ...state,
                statusPegawai: {
                    ...state.statusPegawai,
                    list: action.payload,
                    statusPegawaiChoice: listStatPegawai
                }
            }
        }
        case GET_DETAIL_STATUS_PEGAWAI: {
            return {
                ...state,
                statusPegawai: {
                    ...state.statusPegawai,
                    detail: action.payload
                }
            }
        }
        case GET_PENGHARGAAN_SLKS: {
            return {
                ...state,
                penghargaanSlks: {
                    ...state.penghargaanSlks,
                    list: action.payload
                }
            }
        }
        case GET_DETAIL_PENGHARGAAN_SLKS: {
            return {
                ...state,
                penghargaanSlks: {
                    ...state.penghargaanSlks,
                    detail: action.payload
                }
            }
        }
        case GET_GENDER: {
            const genderResults = action?.payload?.results || action.payload?.result
            const listGender = genderResults.filter((item) => item.nama !== null)
            const tmpChoice = listGender.map((item) => ({ id: item.id, label: item.nama }))

            return {
                ...state,
                gender: {
                    ...state.gender,
                    list: action.payload,
                    genderChoice: tmpChoice
                }
            }
        }
        case GET_DETAIL_GENDER: {
            return {
                ...state,
                gender: {
                    ...state.gender,
                    detail: action.payload
                }
            }
        }
        case GET_PERKAWINAN: {
            return {
                ...state,
                perkawinan: {
                    ...state.perkawinan,
                    list: action.payload
                }
            }
        }
        case GET_DETAIL_PERKAWINAN: {
            return {
                ...state,
                perkawinan: {
                    ...state.perkawinan,
                    detail: action.payload
                }
            }
        }
        case GET_AGAMA: {
            const agamaResults = action?.payload?.results || action.payload?.result
            const listAgama = agamaResults.filter((item) => item.nama !== null)
            const tmpChoice = listAgama.map((item) => ({ id: item.id, label: item.nama }))

            return {
                ...state,
                agama: {
                    ...state.agama,
                    list: agamaResults,
                    agamaChoice: tmpChoice
                }
            }
        }
        case GET_DETAIL_AGAMA: {
            return {
                ...state,
                agama: {
                    ...state.agama,
                    detail: action.payload
                }
            }
        }
        case GET_GOLDAR: {
            const genderResults = action?.payload?.results || action.payload.result
            const listGoldar = genderResults.filter((item) => item.nama !== null)
            const tmpChoice = listGoldar.map((item) => ({ id: item.id, label: item.nama }))
            return {
                ...state,
                golDar: {
                    ...state.golDar,
                    list: genderResults,
                    goldarChoice: tmpChoice
                }
            }
        }
        case GET_DETAIL_GOLDAR: {
            return {
                ...state,
                golDar: {
                    ...state.golDar,
                    detail: action.payload
                }
            }
        }
        case GET_UNKER: {
            const unkerResults = action?.payload?.results || action?.payload?.result
            const listUnker = unkerResults.filter((item) => item.nama !== null)
            const tmpChoice = listUnker.map((item) => ({ id: item.id, label: item.nama, kode: item.kode, id_kode: item.id_kode || '' }))

            return {
                ...state,
                unker: {
                    ...state.unker,
                    list: action.payload,
                    unkerChoice: tmpChoice
                }
            }
        }
        case GET_ALL_UNKER: {
            const unkerResults = action?.payload?.results || action?.payload?.result
            const listUnker = unkerResults.filter((item) => item.nama !== null)
            const tmpChoice = listUnker.map((item) => ({ id: item.id, label: item.nama, kode: item.kode, id_kode: item.id_kode || '' }))

            return {
                ...state,
                unker: {
                    ...state.unker,
                    unkerAllChoice: tmpChoice
                }
            }
        }
        case GET_UNKER_GENERAL: {
            const unkerResults = action?.payload?.result
            const listUnker = unkerResults.filter((item) => item.name !== null)
            const tmpChoice = listUnker.map((item) => ({ id: item.id, label: item.name, ...item }))

            return {
                ...state,
                unker: {
                    ...state.unker,
                    unkerGeneralChoice: tmpChoice
                }
            }
        }
        case GET_UNKER_CHOICE: {
            const unkerResults = action?.payload?.result
            const listUnkerLevel = unkerResults.filter((item) => item.nama !== null)
            const tmpChoice = listUnkerLevel.map((item) => ({ id: item.id, kode: item.kode, label: item.nama }))

            return {
                ...state,
                unker: {
                    ...state.unker,
                    unkerLevel: {
                        ...state.unker.unkerLevel,
                        level: action.payload.level,
                        choice: tmpChoice
                    }
                }
            }
        }
        case RESET_UNKER_LEVEL_CHOICE: {
            return {
                ...state,
                unker: {
                    ...state.unker,
                    unkerLevel: {
                        level: '',
                        choice: []
                    }
                }
            }
        }
        case GET_JABATAN_BY_UNKER: {
            const tipe = action.payload.tipeJabatan ?? 3
            const jabatanResults = action?.payload?.result
            let tmpChoice = []

            if (tipe === 1) {    // default tipe struktural
                tmpChoice = jabatanResults.map((item) => ({ id: item.id, label: item.jenjang || item.nama, eselon: { id: item.unit_kerja?.eselon_detail?.kode, label: item.unit_kerja?.eselon_detail?.nama, pk_id: item.unit_kerja?.eselon_detail?.id } }))
            } else if (tipe === 2) { // tipe Fungsional Tertentu
                tmpChoice = jabatanResults.map((item) => ({ id: item.id, label: `${item.kode || '-'} ${item.nama} ${item.jenjang || '-'}`, eselon: item.eselon_id }))
            } else if (tipe === 3) {    // tipe Fungsional Umum
                tmpChoice = jabatanResults.map((item) => ({ id: item.id, label: item.nama, eselon: item.eselon_id }))
            }

            return {
                ...state,
                jabatan: {
                    ...state.jabatan,
                    byUnker: {
                        ...state.jabatan.byUnker,
                        list: jabatanResults,
                        choice: tmpChoice
                    }
                }
            }
        }
        case GET_JABATAN: {
            let tmpChoice = []
            const result = action.payload.results || action.payload.result
            tmpChoice = result.map((item) => ({ id: item.id, label: item.nama, ...item }))

            return {
                ...state,
                jabatan: {
                    ...state.jabatan,
                    list: result,
                    choice: tmpChoice,
                }
            }
        }
        case RESET_JABATAN_OPTION: {
            return {
                ...state,
                jabatan: {
                    ...state.jabatan,
                    list: null,
                    choice: [],
                }
            }
        }
        case GET_TIM_KERJA: {
            return {
                ...state,
                timKerja: {
                    ...state.timKerja,
                    list: action.payload
                }
            }
        }
        case GET_FORMASI_CPNS: {
            return {
                ...state,
                formasiCPNS: {
                    ...state.formasiCPNS,
                    list: action.payload
                }
            }
        }
        case GET_STATUS_FORMASI_CPNS: {
            return {
                ...state,
                statusFormasiCPNS: {
                    ...state.statusFormasiCPNS,
                    list: action.payload
                }
            }
        }
        case GET_CPNS_FUNGSIONAL_TIPE: {
            return {
                ...state,
                tipeCPNSFungsional: {
                    ...state.tipeCPNSFungsional,
                    list: action.payload
                }
            }
        }
        case GET_CPNS_FUNGSIONAL_KODE: {
            return {
                ...state,
                kodeCPNSFungsional: {
                    ...state.kodeCPNSFungsional,
                    list: action.payload
                }
            }
        }
        case GET_LIST_PENDIDIKAN: {
            const result = action?.payload?.result
            const listPendidikan = result.filter((item) => item !== null)
            const tmpChoice = listPendidikan.map((item) => ({ id: item.tkPendidikanTerakhir, label: item.tkPendidikanTerakhir, ...item }))
            return {
                ...state,
                listPendidikan: {
                    ...state.listPendidikan,
                    list: tmpChoice
                }
            }
        }
        case GET_LIST_TINGKAT_PENDIDIKAN: {
            const result = action?.payload?.result
            const listTingkatPendidikan = result.filter((item) => item !== null)
            const tmpChoice = listTingkatPendidikan.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                listTingkatPendidikan: {
                    ...state.listTingkatPendidikan,
                    list: action.payload,
                    option: tmpChoice
                }
            }
        }
        case GET_LIST_PRODI: {
            const result = action?.payload?.result
            const listProdi = result.filter((item) => item !== null)
            const tmpChoice = listProdi.map((item) => ({ id: item, label: item }))
            return {
                ...state,
                listProdi: {
                    ...state.listProdi,
                    list: tmpChoice
                }
            }
        }
        case GET_SEARCH_PEGAWAI: {
            const option = []
            const data = action.payload

            data.results.map(item => {
                option.push({
                    id: item.nip,
                    label: `${item.nip}/${item.nama}`,
                    nip: item.nip,
                    nama: item.nama,
                    jabatan: item.jabatan
                })
            })

            return {
                ...state,
                pegawai: {
                    ...state.pegawai,
                    list: action.payload,
                    option: option
                }
            }
        }
        case RESET_SEARCH_PEGAWAI: {
            return {
                ...state,
                pegawai: {
                    list: null,
                    option: []
                }
            }
        }
        case GET_LOKASI: {
            const lokasiResults = action?.payload?.result
            const listLokasi = lokasiResults.filter((item) => item.nama !== null)
            const tmpChoice = listLokasi.map((item) => ({ id: item.key, label: item.name }))

            return {
                ...state,
                lokasi: {
                    ...state.lokasi,
                    list: action.payload,
                    lokasiChoice: tmpChoice
                }
            }
        }
        case GET_LIST_NEGARA: {
            const result = action?.payload?.result
            const tmpChoice = result.map((item) => ({ id: item.nama, label: item.nama, pk_id: item.id }))
            return {
                ...state,
                negara: {
                    ...state.negara,
                    option: tmpChoice,
                }
            }
        }
        case GET_PROVINSI_BY_NEGARA: {
            const result = action?.payload?.results || action?.payload?.result
            const listProvinsi = result.filter((item) => item !== null)
            const tmpChoice = listProvinsi.map((item) => ({ id: item.nama, label: item.nama, pk_id: item.id }))
            return {
                ...state,
                provinsi: {
                    ...state.provinsi,
                    list: action.payload,
                    option: tmpChoice,
                }
            }
        }
        case GET_KOTA_BY_PROVINSI: {
            const result = action?.payload?.results || action?.payload?.result
            const listKota = result.filter((item) => item !== null)
            const tmpChoice = listKota.map((item) => ({ id: item.nama, label: item.nama, pk_id: item.id }))
            return {
                ...state,
                kota: {
                    ...state.kota,
                    list: action.payload,
                    option: tmpChoice,
                }
            }
        }
        case GET_KECAMATAN_BY_KOTA: {
            const result = action?.payload?.results || action?.payload?.result
            const listKecamatan = result.filter((item) => item !== null)
            const tmpChoice = listKecamatan.map((item) => ({ id: item.nama, label: item.nama, pk_id: item.id }))
            return {
                ...state,
                kecamatan: {
                    ...state.kecamatan,
                    list: action.payload,
                    option: tmpChoice
                }
            }
        }
        case GET_KELURAHAN_BY_KECAMATAN: {
            const result = action?.payload?.results || action?.payload?.result
            const listKelurahan = result.filter((item) => item !== null)
            const tmpChoice = listKelurahan.map((item) => ({ id: item.nama, label: item.nama, pk_id: item.id }))
            return {
                ...state,
                kelurahan: {
                    ...state.kelurahan,
                    list: action.payload,
                    option: tmpChoice
                }
            }
        }
        case GET_LIST_ESELON: {
            const result = action?.payload?.results
            const listEselon = result.filter((item) => item !== null)
            const tmpChoice = listEselon.map((item) => ({ id: item.id, label: item.nama, kode: item.kode }))

            return {
                ...state,
                eselon: {
                    ...state.eselon,
                    list: action?.payload,
                    eselonChoice: tmpChoice
                }
            }
        }
        case GET_LIST_PENDIDIKAN_ID: {
            const result = action?.payload?.results || action?.payload?.result
            const listPendidikanId = result.filter((item) => item !== null)
            const tmpChoice = listPendidikanId.map((item) => ({ id: item.tkPendidikanTerakirId, label: item.tkPendidikanTerakhir }))
            return {
                ...state,
                pendidikanId: {
                    ...state.pendidikanId,
                    list: action.payload,
                    option: tmpChoice
                }
            }
        }
        case GET_LIST_PRODI_BY_PENDIDIKAN: {
            const result = action?.payload?.result || action?.payload?.result
            const listProdi = result.filter((item) => item !== null)
            const tmpChoice = listProdi.map((item) => ({ id: item.pendidikanTerakhirNama, label: item.pendidikanTerakhirNama }))
            return {
                ...state,
                prodiByPendidikan: {
                    ...state.prodiByPendidikan,
                    list: action.payload,
                    option: tmpChoice
                }
            }
        }
        case GET_LIST_CLUSTER: {
            const result = action?.payload?.result
            const listCluster = result.filter((item) => item !== null)
            const tmpChoice = listCluster.map((item) => ({ id: item.nama, label: item.nama }))
            return {
                ...state,
                listCluster: {
                    ...state.listCluster,
                    list: action.payload,
                    option: tmpChoice
                }
            }
        }
        case GET_LIST_SUBCLUSTER: {
            const result = action?.payload?.result
            const listSubcluster = result.filter((item) => item !== null)
            const tmpChoice = listSubcluster.map((item) => ({ id: item.nama, label: item.nama }))
            return {
                ...state,
                listSubcluster: {
                    ...state.listSubcluster,
                    list: action.payload,
                    option: tmpChoice
                }
            }
        }
        case GET_LIST_GOLONGAN: {
            const result = action?.payload?.results || action?.payload?.result
            const listGolongan = result.filter((item) => item !== null)
            const tmpChoice = listGolongan.map((item) => ({ id: item.gol_ruang_akhir_id, label: item.gol_ruang_akhir }))
            return {
                ...state,
                listGolongan: {
                    ...state.listGolongan,
                    list: action.payload,
                    option: tmpChoice
                }
            }
        }
        case GET_LIST_TIPE_JABATAN: {
            const result = action?.payload?.result
            const listTipeJabatan = result.filter((item) => item !== null)
            const tmpChoice = listTipeJabatan.map((item) => ({ id: item.jenis_jabatan, label: item.jenis_jabatan }))

            return {
                ...state,
                tipeJabatan: {
                    ...state.eselon,
                    list: action?.payload,
                    tipeJabatanChoice: tmpChoice
                }
            }
        }
        case GET_LIST_JABFUNG_GENERAL: {
            const jabatanResults = action?.payload?.results || action?.payload?.result
            const listJabatanFungsional = jabatanResults.filter((item) => item.nama_jabatan_fungsional !== null)
            const tmpChoice = listJabatanFungsional.map((item) => ({ id: item.nama_jabatan_fungsional, label: item.nama_jabatan_fungsional }))

            return {
                ...state,
                listJabfung: {
                    ...state.listJabfung,
                    jabfungGeneralChoice: tmpChoice
                }
            }
        }
        case GET_LIST_JABFUNG: {
            let tmpChoice = []
            const type = action?.payload?.type
            const result = action?.payload?.data?.result

            if (type === 'lite') {
                tmpChoice = result.map((item) => ({ id: item?.kode, label: item?.value }))
            } else {
                tmpChoice = result.map((item) => ({ id: item?.kode, label: `${item?.kode}-${item?.nama}` || '-', header: item?.nama }))
            }

            return {
                ...state,
                listJabfung: {
                    ...state.listJabfung,
                    list: action.payload.data,
                    option: tmpChoice
                }
            }
        }
        case RESET_LIST_JABFUNG: {
            return {
                ...state,
                listJabfung: {
                    ...state.listJabfung,
                    list: null,
                    option: [],
                }
            }
        }
        case GET_PELANGGARAN_PP: {
            const result = action.payload.result
            const tmpChoice = result.map((item) => ({ id: item.key, label: item.nama }))
            return {
                ...state,
                pelanggaranPPOption: {
                    ...state.pelanggaranPPOption,
                    list: result,
                    choice: tmpChoice
                }
            }
        }
        case GET_KODE_HUKUMAN: {
            const result = action.payload.result
            const tmpChoice = result.map((item) => ({ id: item.key, label: item.nama }))

            return {
                ...state,
                kodeHukumanOption: {
                    ...state.kodeHukumanOption,
                    list: result,
                    choice: tmpChoice
                }
            }
        }
        case GET_KODE_PEJABAT_BERWENANG: {
            const result = action.payload.result
            const tmpChoice = result.map((item) => ({ id: item.key, label: item.nama }))

            return {
                ...state,
                kodePejabatBerwenangOption: {
                    ...state.kodePejabatBerwenangOption,
                    list: result,
                    choice: tmpChoice
                }
            }
        }
        case GET_PENYAMPAIAN_KEPUTUSAN_HUKUMAN: {
            const result = action.payload.result
            const tmpChoice = result.map((item) => ({ id: item.key, label: item.nama }))

            return {
                ...state,
                pkhOption: {
                    ...state.pkhOption,
                    list: result,
                    choice: tmpChoice
                }
            }
        }
        case GET_UPAYA_ADMINISTRATIF: {
            const result = action.payload.result
            const tmpChoice = result.map((item) => ({ id: item.key, label: item.nama }))

            return {
                ...state,
                upayaAdministratifOption: {
                    ...state.upayaAdministratifOption,
                    list: result,
                    choice: tmpChoice
                }
            }
        }
        case GET_STATUS_HUKDIS: {
            const result = action.payload.result
            const tmpChoice = result.map((item) => ({ id: item.key, label: item.nama }))

            return {
                ...state,
                statusHukdisOption: {
                    ...state.statusHukdisOption,
                    list: result,
                    choice: tmpChoice
                }
            }
        }
        case GET_LIST_GAJI: {
            return {
                ...state,
                gaji: {
                    ...state.gaji,
                    list: action.payload,
                }
            }
        }
        case GET_LIST_GOLONGAN_CHOICE: {
            const result = action.payload.result
            const tmpChoice = result.map((item) => ({ id: item.key, label: item.name }))

            return {
                ...state,
                golonganChoice: {
                    ...state.golonganChoice,
                    choice: tmpChoice,
                }
            }
        }
        case GET_KATEGORI_PP_PELANGGARAN: {
            const kategori = action?.payload?.results || action?.payload?.result
            const listKategori = kategori.filter((item) => item.nama !== null)
            const tmpChoice = listKategori.map((item) => ({ id: item.id, label: item.nama }))

            return {
                ...state,
                kategoriPPPelanggaran: {
                    ...state.kategoriPPPelanggaran,
                    choice: tmpChoice
                }
            }
        }
        case GET_OPTION_SHIFT: {
            const tmpChoice = action.payload.result.map((item) => ({ id: item.key, label: item.name }))

            return {
                ...state,
                shiftJadwalKerja: {
                    choice: tmpChoice
                }
            }
        }
        case GET_OPTION_JURUSAN: {
            const listJurusan = action.payload.result.filter((item) => item.name !== '')
            const tmpChoice = listJurusan.map((item) => ({ id: item.key, label: item.nama, ...item }))

            return {
                ...state,
                listJurusan: {
                    choice: tmpChoice
                }
            }
        }
        case RESET_OPTION_JURUSAN: {
            return {
                ...state,
                listJurusan: {
                    choice: []
                }
            }
        }
        case GET_OPTION_SEKOLAH: {
            const tmpChoice = action.payload.result.map((item) => ({ id: item.key, label: item.name }))

            return {
                ...state,
                listSekolah: {
                    choice: tmpChoice
                }
            }
        }
        case GET_OPTION_JENIS_DIKLAT: {
            const tmpChoice = action.payload.result.map((item) => ({ id: item.key, label: item.name }))

            return {
                ...state,
                jenisDiklatOption: {
                    choice: tmpChoice
                }
            }
        }
        case GET_OPTION_KATEGORI_DIKLAT: {
            const tmpChoice = action.payload.result.map((item) => ({ id: item.key, label: item.name }))

            return {
                ...state,
                kategoriDiklatOption: {
                    choice: tmpChoice
                }
            }
        }
        case GET_ESELON_OPTION: {
            const tmpChoice = action.payload.result.map((item) => ({ id: item.key, label: item.nama, ...item }))
            return {
                ...state,
                eselon: {
                    ...state.eselon,
                    eselonPNSOption: tmpChoice,
                }
            }
        }
        case GET_PEGAWAI_PENSIUN_OPTION: {
            const tmpChoice = action.payload.result.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                pegawaiPensiunOption: {
                    choice: tmpChoice
                }
            }
        }
        case GET_LIST_MENUS: {
            const tmpChoice = action.payload.result.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                menu: {
                    choice: tmpChoice
                }
            }
        }
        case GET_OPTION_BIDANG_KEAHLIAN: {
            const tmpChoice = action.payload.result.map((item) => ({ id: item.id, label: item.nama }))
            return {
                ...state,
                bidangKeahlian: {
                    choice: [...tmpChoice, { id: 'LAINNYA', label: 'Lainnya' }]
                }
            }
        }
        case GET_KATEGORI_ASN_V2: {
            const kategoriAsnV2Results = action?.payload?.results || action.payload?.result
            const listKategoriAsnV2 = kategoriAsnV2Results.filter((item) => item.nama !== null)
            const tmpChoice = listKategoriAsnV2.map((item) => ({ id: item.key, label: item.nama }))

            return {
                ...state,
                kategoriAsnV2: {
                    ...state.kategoriAsnV2,
                    list: kategoriAsnV2Results,
                    kategoriAsnV2Choice: tmpChoice
                }
            }
        }
        case GET_KATEGORI_ASN_TIPE_V2: {
            const tipeKategoriAsnResults = action?.payload?.results || action.payload?.result
            const listTipeKategoriAsn = tipeKategoriAsnResults.filter((item) => item.nama !== null)
            const tmpChoice = listTipeKategoriAsn.map((item) => ({ id: item.key, label: item.nama, ...item }))

            return {
                ...state,
                tipeKategoriASNV2: {
                    ...state.tipeKategoriASNV2,
                    list: listTipeKategoriAsn,
                    tipeKategoriASNV2Choice: tmpChoice,
                },
            }
        }
        case RESET_KATEGORI_ASN_TIPE_V2: {
            return {
                ...state,
                tipeKategoriASNV2: {
                    ...state.tipeKategoriASNV2,
                    list: [],
                    tipeKategoriASNV2Choice: [],
                },
            }
        }
        case GET_OPTION_PROGRAM_KERJA: {
            const results = action.payload?.result
            const list = results.filter((item) => item.nama !== null)
            const tmpChoice = list.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                programKerja: {
                    ...state.programKerja,
                    tipe: tmpChoice,
                }
            }
        }
        case GET_OPTION_STATUS_PROGRAM_KERJA: {
            const results = action.payload?.result
            const list = results.filter((item) => item.nama !== null)
            const tmpChoice = list.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                programKerja: {
                    ...state.programKerja,
                    status: tmpChoice,
                }
            }
        }
        case GET_OPTION_INTERVENSI_PROGRAM_KERJA: {
            const results = action.payload?.result
            const list = results.filter((item) => item.nama !== null)
            const tmpChoice = list.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                programKerja: {
                    ...state.programKerja,
                    intervensi: tmpChoice,
                }
            }
        }
        case GET_OPTION_INDIKATOR_ASSESSMENT: {
            const results = action.payload?.result
            const list = results.filter((item) => item.name !== null)
            const tmpChoice = list.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                indikatorAssessment: {
                    list: action.payload,
                    choice: tmpChoice,
                }
            }
        }
        case GET_OPTION_PENGHARGAAN_ASN: {
            const penghargaanResults = action?.payload?.results || action.payload?.result
            const listPenghargaan = penghargaanResults.filter((item) => item.nama !== null)
            const tmpChoice = listPenghargaan.map((item) => ({ id: item.key, label: item.name }))

            return {
                ...state,
                penghargaanAsn: {
                    ...state.penghargaanAsn,
                    list: action.payload,
                    choice: tmpChoice
                }
            }
        }
        default:
            return state;
    }
};
export default filterReducer;
